import React from "react";
import { Icon } from "@iconify/react";

const HireMe = () => {
	return (
		<div className="rounded-sm bg-[url(./assets/img/bg-collaboration.jpg)] bg-cover py-16 px-20 text-white">
			<h2 className="text-center font-anton text-[40px]">
				Let's Work Together on Your Next Project
			</h2>
			<div className="mt-10 mb-5 text-center">
				<button className="btn-main font-bold uppercase">Hire Me Now</button>
			</div>
			<div className="text-center">
				<button className="mx-auto flex items-center gap-2 font-montserrat text-sm font-semibold text-grey">
					<Icon icon="eva:download-fill" className="text-2xl text-main" />
					Download CV
				</button>
			</div>
		</div>
	);
};

export default HireMe;
